import React, {
  Fragment,
  FC,
}                        from 'react';
import {
  Field,
  Form,
  Formik,
  FormikProps,
  FormikConfig,
}                        from 'formik';
import * as Yup          from 'yup';
import styled            from 'styled-components';
import { Paper }         from '@material-ui/core';
import {
  INote,
  INoteValues,
}                        from '@typings/accountManagement';
import { TextInputGray } from '@components/TextInputGray/TextInputGray';
import { Button }        from '@components/index';
import { Note }          from '@modules/accountManagement/components/Note';

const AddNoteButton = styled(Button)`
  && {
    float: right;
  }
`;

const NotesHeaderWrapper = styled.div`
  width           : 100%;
  display         : flex;
  justify-content : space-between;
  align-items     : baseline;
  padding         : 20px;

  && {
    button {
      height     : 43px;
      margin-top : 15px;
    }
  }
`;

const NotesSectionWrapper = styled(Paper)`
  ${NotesHeaderWrapper} {
    flex-direction: row;
  }
`;

const NotesFormWrapper = styled.div`
  display        : flex;
  flex-direction : column;
  width          : 100%;
  padding        : 0 20px;
`;

const NotesWrapper = styled.div`
  margin-top  : 25px;
  border-top  : 1px solid #DDDDDD;
  padding-top : 10px;
  max-height  : 500px;
  overflow-x  : auto;
`;

const Splitter = styled.div`
  width         : 100%;
  border-bottom : 1px solid #DDDDDD;
`;

const validationSchema: Yup.Schema<INoteValues> = Yup.object().shape({
  text: Yup.string().min(3).required(),
});

interface IProps {
  onAddNewNote          : FormikConfig<INoteValues>['onSubmit'];
  notes                 : INote[];
  handleToggleNoteModal : (note: INote | null) => void;
}

export const AddNote: FC<IProps> = ({
  notes = [],
  onAddNewNote,
  handleToggleNoteModal,
}) => (
  <NotesSectionWrapper>
    <NotesHeaderWrapper>
      <h2>Notes</h2>
    </NotesHeaderWrapper>

    <Formik
      validationSchema = {validationSchema}
      initialValues    = {{ text: '' }}
      onSubmit         = {onAddNewNote}
    >
      {({
        dirty,
        isValid,
        isSubmitting,
      }: FormikProps<INoteValues>): JSX.Element => (
        <NotesFormWrapper>
          <Form>
            <Field
              id          = "text"
              name        = "text"
              placeholder = "Type your notes..."
              component   = {TextInputGray}
              inputProps  = {{ maxLength: 500 }}
              multiline
            />

            <AddNoteButton
              type      = "submit"
              label     = "Add Note"
              margin    = "20px 0"
              isLoading = {isSubmitting}
              disabled  = {!isValid || !dirty || isSubmitting}
            />
          </Form>
        </NotesFormWrapper>
      )}
    </Formik>

    <NotesWrapper>
      {notes.map((note, index): JSX.Element => (
        <Fragment key={note?.id || index}>
          {index ? <Splitter /> : null}

          <Note
            note                  = {note}
            handleToggleNoteModal = {handleToggleNoteModal}
          />
        </Fragment>
      ))}
    </NotesWrapper>
  </NotesSectionWrapper>
);
